import React from "react";
import { StyledUnreadMark } from "./UnReadMark.styled";

type UnreadMarkProps = {
  visible?: boolean;
  size?: "small" | "medium";
};
export const UnReadMark = ({
  visible = false,
  size = "small",
}: UnreadMarkProps) => {
  return (
    <StyledUnreadMark
      data-testid="unread-mark-test"
      $visible={visible}
      $size={size}
    />
  );
};
